module.exports = __webpack_public_path__ + "img/coor-part3.24d68182.png";